import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AppDispatch } from '../../store';
import { forgetPassword } from '../../features/auth/registerSlice';
import Input from '../ui/Input';
import toast from 'react-hot-toast';

const ResetPasswordStep = ({ phone }: { phone: string }) => {
  const { t } = useTranslation();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const isValidPassword = (password: string) => {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    return regex.test(password);
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      toast.error(t("password-not-matches"))
    } else if(!isValidPassword(password)) {
      toast.error(t("password-invalid"));
    } else {
      try {
        const res = await dispatch(
          forgetPassword({ data: { phone: phone as string, password } })
        ).unwrap();
        if (res.success) {
          toast.success(t("passwordChanged"));
          navigate("/auth/login");
        }
      } catch (error) {
        toast.error(t("errorOccurred"));
      }
    }

  };


  return (
    <div className=' flex flex-col gap-4'>
      <h2 className='text-2xl font-semibold mb-3'>{t("reset-password")}</h2>
      <Input value={password} onChange={(e) => setPassword(e.target.value)} type='password' name='password' text={t("password")} required />
      <Input value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} type='password' name='confirm-password' text={t("confirm-password")} required />
      <button
        onClick={handleSubmit}
        className='w-full bg-secondry text-white py-3 rounded-lg'
      >
        {t("confirm")}
      </button>
    </div>
  );
};

export default ResetPasswordStep;
